const supplementsTranslations = {
  title: "Supplements",
  home: "Home",
  supplements: "Supplements",
  tableTitle: "This is your supplements",
  supplementsName: "Supplements Name",
  supplementsDescription: "Supplements Description",
  noSupplementsNote: {
    title: "No Supplements Needed !",
    description:
      "Your nutrition plan is complete, and you don't need any supplements.",
  },
};

export default supplementsTranslations;
